<template>
  <Modal title="全体老师请假" v-model="visible" width="880">
    <Form ref="leaveForm" class="form" :label-width="80"
      :model="leaveParam" :rules="leaveRule">
      <Row>
        <Col :span="22" >
          <Form-item label="选择时间">
            <Row>
              <Col span="6">
                <Form-item prop="startTime">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                    @on-change="startTimeChange"></Date-picker>
                </Form-item>
              </Col>
              <Col span="1" style="text-align: center">-</Col>
              <Col span="6">
                <Form-item prop="endTime">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间"
                    @on-change="endTimeChange"></Date-picker>
                  </Form-item>
              </Col>
            </Row>
          </Form-item>
        </Col>
        <Col :span="16">
          <Form-item label="请假原因" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="leaveParam.remark" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AllTchLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingAdd: false,
        leaveParam: {
          startTime: '',
          endTime: '',
          remark: ''
        },
        leaveRule: {
          startTime: [
            { required: true, message: '请选择开始时间', trigger: 'blur' },
          ],
          endTime: [
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],
          remark: [
            { required: true, max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      add () {
        let self = this
        this.$refs.leaveForm.validate((valid) => {
          if (!valid) {
            return
          }
          self.loadingAdd = true
          let params = self.leaveParam
          self.$http.post('/bookTchLeaveTime/allTchLeave', params).then(function (res) {
            self.loadingAdd = false
            if (res && res.data > 0) {
//              self.successCallback()
              self.$Message.success('请假成功!')
              self.visible = false
            }
          }).catch(function (e) {
            self.loadingAdd = false
          })
        })
      },
      startTimeChange (value) {
        this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeChange (value) {
        this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AllTchLeaveModal.vue?98c489ce